import Model from "./model";
import store from '@/store'

export default new Model({
  resource : "campo",
  inputs:[
    {label:"ID", nameAttr:"id", default:null, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"-", required: true, type:"text", width: 300},
    {label:"Código", nameAttr:"codigo", default:"-", required: true, type:"text", width: 100},
    {label:"Empresa", nameAttr:"empresa_id", default:null, required: true, type:"select", model:"empresaModel", searchPath:"nombre", width:150,
      mapValueFn:(itemForm, item) => {
        itemForm.list = _.filter(itemForm.list, item => {
          return _.find(store.getters.empresas, {id: item.id})
        })
        return itemForm;
      },
    },
    

    {
      label      : "Usuarios",
      nameAttr   : "usuarios",
      //renameAttr : "rol",
      itemText   : "name",
      //itemValue  : "name",
      //rootPath   : "data.roles",
      default    : [],
      map          : "id",          //esto transforma un array de objects en un array de ids con el nombre cuarteles_id [nameAttrMap]
      required   : false,
      type       : "multiSelect",
      model      : "userModel",
      searchPath : "name",
      width      : 150,
    //mapeo de value, cuando vienen de un model separado
    //lee los array con formato {add: Boolean, name: String}
    /*
    mapValueFn:(itemForm, item) => {
      return _.map(item.roles, (rol)=>{
        var find =  _.find(itemForm.list, {name: rol});
        return find ? find.id : null;
      })
    },
    */
    //mapeo de value, previo a guardar
    //guarda los array con formato {add: Boolean, name: String}
  },
  ]
});
